<div class="wm-l-dialog" data-testing-id="confirm-dialog-popup">
  <div class="dialog-content-container">
    @if (!!icon) {
      <fa-icon class="icon" size="3x" [icon]="icon" data-testing-id="confirm-dialog-popup-icon"></fa-icon>
    }
    @if (msg) {
      <div class="wm-l-dialog-msg" data-testing-id="confirm-dialog-popup-message">{{msg}}</div>
    }
    @if (htmlMsg) {
      <div class="wm-l-dialog-msg dialog-html-content" data-testing-id="confirm-dialog-popup-message-html" [innerHTML]="htmlMsg | unsafeSecurityBypassedHtml"></div>
    }
  </div>
  <div class="wm-l-dialog-control">
    <button pButton class="p-button-outlined wm-l-dialog-cancel" (click)="ref.close('cancel')" data-testing-id="confirm-dialog-popup-cancel">{{cancelText}}</button>
    <button pButton class="wm-l-dialog-confirm" (click)="ref.close('confirm')" data-testing-id="confirm-dialog-popup-confirm">{{confirmText}}</button>
  </div>
  @if (thirdOptionText) {
    <div class="dialog-tertiary-action">
      <span (click)="ref.close('thirdOption')">{{thirdOptionText}}</span>
    </div>
  }
</div>
